"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable no-alert */
/* eslint-disable no-restricted-globals */
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const react_intl_1 = require("react-intl");
const styled_components_1 = __importDefault(require("styled-components"));
const elements_1 = require("@src/components/elements");
const useAppMutation_1 = require("@src/hooks/useAppMutation");
const admin_1 = require("@src/api/admin");
const react_query_1 = require("react-query");
const queries_1 = require("@src/types/queries");
const admin_context_1 = require("../../admin-context");
const SubHeadline = styled_components_1.default.strong `
	font-size: 1.2rem;
`;
const Api = () => {
    var _a, _b;
    const intl = (0, react_intl_1.useIntl)();
    const queryClient = (0, react_query_1.useQueryClient)();
    const { companyInfo } = (0, admin_context_1.useAdminContextValue)();
    const { mutateAsync: generateApiKey, isLoading } = (0, useAppMutation_1.useAppMutation)(admin_1.generateNewApiKey, {
        onSuccess: () => {
            queryClient.invalidateQueries(queries_1.Queries.getCompany);
        },
    });
    const copyToClipboard = () => {
        const input = document.getElementById('api-key-input');
        if (input) {
            // @ts-ignore
            input.select();
            document.execCommand('copy');
            input.blur();
        }
        antd_1.notification.success({
            message: intl.formatMessage({
                id: 'admin.api.message',
            }),
            description: intl.formatMessage({
                id: 'admin.api.copy_api_key',
            }),
        });
    };
    const hasApiKey = !!((_a = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyApiKey) === null || _a === void 0 ? void 0 : _a.key);
    return ((0, jsx_runtime_1.jsxs)(elements_1.Panel, { children: [(0, jsx_runtime_1.jsx)(antd_1.Row, { children: (0, jsx_runtime_1.jsxs)(antd_1.Col, { xs: 24, children: [(0, jsx_runtime_1.jsx)(elements_1.Title, { level: 1, type: "secondary", align: "center", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.api.title" }) }), (0, jsx_runtime_1.jsx)(SubHeadline, { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.api.description" }) }), (0, jsx_runtime_1.jsx)("div", { className: "m-t-l", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.api.example", values: {
                                    strong: chunks => (0, jsx_runtime_1.jsx)("strong", { children: chunks }),
                                    breakingLine: (0, jsx_runtime_1.jsx)("br", {}),
                                } }) }), (0, jsx_runtime_1.jsx)("div", { className: "m-t-m m-b-m", children: (0, jsx_runtime_1.jsx)("a", { href: "https://documenter.getpostman.com/view/6622469/RztrKnDf", target: "_blank", rel: "noopener noreferrer", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.api.documentation_here" }) }) })] }) }), (0, jsx_runtime_1.jsxs)("div", { className: "panel panel--secondary", children: [(0, jsx_runtime_1.jsx)(antd_1.Row, { children: (0, jsx_runtime_1.jsx)(antd_1.Col, { xs: 24, children: (0, jsx_runtime_1.jsx)("input", { id: "api-key-input", className: "form__input api-input", value: (_b = companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyApiKey) === null || _b === void 0 ? void 0 : _b.key, type: "text", onDoubleClick: () => copyToClipboard() }) }) }), (0, jsx_runtime_1.jsx)(antd_1.Row, { justify: "center", children: (0, jsx_runtime_1.jsx)(antd_1.Col, { xs: 24, className: "text-center", children: (0, jsx_runtime_1.jsx)(elements_1.Button, { className: "m-t-m", loading: isLoading, onClick: () => {
                                    if (hasApiKey) {
                                        const hasConfirmed = confirm(intl.formatMessage({
                                            id: 'admin.api.confirm_generating_new_key',
                                        }));
                                        if (hasConfirmed) {
                                            generateApiKey();
                                        }
                                    }
                                    else {
                                        generateApiKey();
                                    }
                                }, children: intl.formatMessage({
                                    id: 'admin.api.generate_new_key',
                                }) }) }) })] })] }));
};
exports.default = Api;
